import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { VitalFlagDefault } from '../patient/rpm/vital-flag-criteria/models/vital_flags.model';
import { FirestoreService } from './firestore.service';

@Injectable({
  providedIn: 'root',
})
export class VitalFlagDefaultService {
  constructor(private firestoreService: FirestoreService) {}

  getDefaultVitalFlags(type: string): Observable<VitalFlagDefault[]> {
    return this.firestoreService.colWithIds$('vital_flag_defaults', (ref) => ref.where('type', '==', type));
  }

  updateDefaultVitalFlag(id: string, data: Partial<VitalFlagDefault>): Promise<void> {
    return this.firestoreService.update(`vital_flag_defaults/${id}`, data);
  }

  async saveDefaultVitalFlags(updates: Array<{ id: string } & Partial<VitalFlagDefault>>): Promise<void> {
    await Promise.all(
      updates.map((u) => {
        const { id, ...data } = u;
        return this.updateDefaultVitalFlag(id, data);
      })
    );
  }
}
